export default "__VITE_ASSET__Brsbk1L1__"